/**
 * @module components\ghInput\textInput
 */
import Vue from "vue";
import Component from "vue-class-component";
import InputBase from "../inputBase";

@Component
export default class TextInput extends InputBase {
  [key: string]: any;
  private input() {}
}
